import { ref, computed } from 'vue';
import { BillingBillStatus, BillingLineStatus } from '../types';
import {
  billingBillStatusTextMap,
  billingBillStatusColorMap,
  billingLineStatusTextMap,
  billingLineStatusColorMap,
  PACKABLE_LINE_STATUSES,
  CANCELABLE_LINE_STATUSES,
  NON_CANCELLABLE_LINE_STATUSES
} from '../constants';

export function useBillingStatus() {
  const getBillStatusText = (status: BillingBillStatus): string => {
    return billingBillStatusTextMap[status] || status;
  };

  const getBillStatusColor = (status: BillingBillStatus): string => {
    return billingBillStatusColorMap[status] || 'default';
  };

  const getLineStatusText = (status: BillingLineStatus): string => {
    return billingLineStatusTextMap[status] || status;
  };

  const getLineStatusColor = (status: BillingLineStatus): string => {
    return billingLineStatusColorMap[status] || 'default';
  };

  const isLinePackable = (status: BillingLineStatus): boolean => {
    return PACKABLE_LINE_STATUSES.includes(status);
  };

  const isLineCancelable = (status: BillingLineStatus): boolean => {
    return CANCELABLE_LINE_STATUSES.includes(status);
  };

  const isLineNonCancelable = (status: BillingLineStatus): boolean => {
    return NON_CANCELLABLE_LINE_STATUSES.includes(status);
  };

  /** 主单按钮可见性 */
  const canConfirm = (status: BillingBillStatus): boolean => {
    return status === BillingBillStatus.PENDING;
  };

  const canEdit = (status: BillingBillStatus): boolean => {
    return status === BillingBillStatus.PENDING || status === BillingBillStatus.CONFIRMING;
  };

  const canImport = (status: BillingBillStatus): boolean => {
    return status === BillingBillStatus.PENDING || status === BillingBillStatus.CONFIRMING;
  };

  const canDownloadInvoice = (status: BillingBillStatus): boolean => {
    return status === BillingBillStatus.CONFIRMING || status === BillingBillStatus.CONFIRMED;
  };

  return {
    getBillStatusText,
    getBillStatusColor,
    getLineStatusText,
    getLineStatusColor,
    isLinePackable,
    isLineCancelable,
    isLineNonCancelable,
    canConfirm,
    canEdit,
    canImport,
    canDownloadInvoice
  };
}
